import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'

import ActionTypes from '../constants'
import {
  PlayerTransactionFilterOptions,
  PlayerTransactionState,
} from '../models'
import { PLAYER_TRANSACTIONS } from './api.routes'

const restApiService = new RestApiService()

export const getFilterOptionsThunk = createAsyncThunk(
  ActionTypes.GET_FILTER_OPTIONS,
  async (_, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState() as ApplicationState

      restApiService.requestParams = {
        method: 'GET',
        endpoint: PLAYER_TRANSACTIONS.FILTER_OPTIONS,
        externalServerURL:
          process.env && process.env.REACT_APP_SERVER_INCENTIVE_API,
      }

      const response: PlayerTransactionFilterOptions =
        await restApiService.getData(auth.brand.siteId.toString(), auth.token)

      return response
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getFilterOptionsExtraReducer = (
  builder: ActionReducerMapBuilder<PlayerTransactionState>,
) => {
  builder.addCase(getFilterOptionsThunk.fulfilled, (state, { payload }) => {
    state.filterOptions = payload
  })
}

export default getFilterOptionsExtraReducer
